import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { getCoords } from "../lib/geo";
import { Sun, Drop, Umbrella, Thermometer } from "@phosphor-icons/react";

// Live heat-safety banner (Cal/OSHA Wage Order 14 §3395).
// Best-effort: renders nothing if location/weather is unavailable.
export const HeatBanner = () => {
  const [wx, setWx] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      const c = await getCoords();
      if (!c || !alive) return;
      try {
        const { data } = await api.get(`/weather/current?lat=${c.lat}&lon=${c.lng}`);
        if (alive && data?.temp_f != null) setWx(data);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  if (!wx || wx.temp_f == null) return null;

  const loc = wx.location_name ? ` · ${wx.location_name}` : "";

  if (wx.heat_alert) {
    return (
      <div
        data-testid="heat-alert-high"
        className="bg-[#7A2E1E] text-[#FBEFE6] border border-[#5A1F12] p-4 shadow-sm shadow-stone-900/10"
      >
        <div className="flex items-center gap-2 font-bold uppercase tracking-wide text-sm">
          <Sun weight="fill" size={20} /> High Heat — {wx.temp_f}°F{loc}
        </div>
        <div className="mt-1 text-xs font-medium flex flex-wrap gap-x-4 gap-y-1">
          <span className="inline-flex items-center gap-1"><Umbrella weight="bold" /> Provide shade & enforce breaks</span>
          <span className="inline-flex items-center gap-1"><Drop weight="bold" /> Cool water every 15 min</span>
          <span>Observe workers for heat illness</span>
        </div>
      </div>
    );
  }

  if (wx.shade_advised) {
    return (
      <div
        data-testid="heat-alert-shade"
        className="bg-[#D8C7A1] border border-stone-300 px-4 py-3 shadow-sm shadow-stone-900/5 flex items-center gap-2 text-sm font-medium"
      >
        <Umbrella weight="bold" size={18} />
        Shade required — {wx.temp_f}°F{loc}
        {wx.weather_desc ? ` · ${wx.weather_desc}` : ""}
      </div>
    );
  }

  return (
    <div
      data-testid="weather-chip"
      className="inline-flex items-center gap-2 bg-white border border-stone-200 px-3 py-1.5 text-xs font-medium text-stone-600"
    >
      <Thermometer weight="bold" size={16} />
      {wx.temp_f}°F{wx.weather_desc ? ` · ${wx.weather_desc}` : ""}{loc}
    </div>
  );
};
